// Tree-shaken Lucide icons. Add an entry here whenever a component uses a
// new data-lucide name - only icons present in this map are bundled.
import { createIcons } from "lucide";
import {
  Activity, AlertCircle, AlertTriangle, Archive, ArrowLeft, ArrowRightLeft, ArrowUpRight,
  Bold, Italic, Underline, Strikethrough, List, ListOrdered, Link, Eraser, Bell, Calendar, Check, CheckCircle2, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, Circle, CloudOff, Copy,
  Download, Eye, EyeOff, ExternalLink,
  Image, File, FileText, Folder, Globe,
  Inbox, Info, KeyRound, LayoutDashboard, Loader2, LogOut,
  Mail, MailOpen, MailPlus, Menu, Minus, MonitorDown, MoreHorizontal,
  Paperclip, Pause, Play, Plus, Presentation,
  RefreshCw, Reply, ReplyAll, RotateCcw, RotateCw,
  Search, Send, Settings, Share2,
  Shield, ShieldCheck, Smartphone, Sparkles, Square, Star, Tag,
  Trash2, User, UserCheck, UserPlus, Users, UsersRound, Wand2, X,
} from "lucide";

const icons = {
  Activity, AlertCircle, AlertTriangle, Archive, ArrowLeft, ArrowRightLeft, ArrowUpRight,
  Bold, Italic, Underline, Strikethrough, List, ListOrdered, Link, Eraser, Bell, Calendar, Check, CheckCircle2, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, Circle, CloudOff, Copy,
  Download, Eye, EyeOff, ExternalLink,
  Image, File, FileText, Folder, Globe,
  Inbox, Info, KeyRound, LayoutDashboard, Loader2, LogOut,
  Mail, MailOpen, MailPlus, Menu, Minus, MonitorDown, MoreHorizontal,
  Paperclip, Pause, Play, Plus, Presentation,
  RefreshCw, Reply, ReplyAll, RotateCcw, RotateCw,
  Search, Send, Settings, Share2,
  Shield, ShieldCheck, Smartphone, Sparkles, Square, Star, Tag,
  Trash2, User, UserCheck, UserPlus, Users, UsersRound, Wand2, X,
};

export function renderIcons(root) {
  createIcons({
    icons,
    nameAttr: "data-lucide",
    attrs: {},
    ...(root && root !== document ? { root } : {}),
  });
}
